// PatientRegistrationDialogs.jsx
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { useCartData } from '../context/CartDataContext';
import { useHistory } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

export function TimeSlotExtendDialog() {
  const {
    showExtendModal,
    handleExtend,
    handleCancel,
    remainingTimeText,
    sessionApiLoading,
  } = useCartData();

  const handleCancelClick = async () => {
    await handleCancel();
    window.location.replace('/');
  };

  return (
    <Dialog open={showExtendModal} onOpenChange={() => {}}>
      <DialogContent className="bg-white max-w-sm">
        <DialogBody>
          <DialogTitle className="text-lg font-semibold text-left text-black">
            Jūsų rezervacija baigsis greitai
          </DialogTitle>
          <p className="text-sm text-muted-foreground mt-2">
            Rezervuotas laikas baigsis po <strong>{remainingTimeText}</strong>.
            Ar norite jį pratęsti?
          </p>
        </DialogBody>
        <DialogFooter className="flex justify-end gap-2">
          <Button
            variant="secondary"
            onClick={handleCancelClick}
            disabled={sessionApiLoading}
          >
            Atšaukti
          </Button>
      
           <Button
          className="hidden sm:flex items-center justify-center gap-2"
          onClick={handleExtend} disabled={sessionApiLoading}
        >
          {sessionApiLoading && (
            <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
          )}
          <span>Pratęsti</span>
        </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

// 🟥 Expired dialog
export function TimeSlotExpiredDialog() {
  const { showExpiredModal, setShowExpiredModal } = useCartData();
  const history = useHistory();

  const handleCancelClick = () => {
    setShowExpiredModal(false);
    history.push('/');
  };
  return (
    <Dialog open={showExpiredModal} onOpenChange={handleCancelClick}>
      <DialogContent className="bg-white max-w-sm">
        <DialogBody>
          <DialogTitle className="text-lg font-semibold text-left text-black">
            Rezervacija baigėsi
          </DialogTitle>
          <p className="text-sm text-muted-foreground mt-2">
            Jūsų rezervuotas laikas buvo atšauktas.
          </p>
        </DialogBody>
        <DialogFooter className="flex justify-end">
          <Button onClick={handleCancelClick}>Uždaryti</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
